import { render, staticRenderFns } from "./AuthForgotPasswordView.vue?vue&type=template&id=25343e42&scoped=true"
import script from "./AuthForgotPasswordView.vue?vue&type=script&lang=ts"
export * from "./AuthForgotPasswordView.vue?vue&type=script&lang=ts"
import style0 from "./AuthForgotPasswordView.vue?vue&type=style&index=0&id=25343e42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25343e42",
  null
  
)

export default component.exports